var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge"},[(_vm.label)?_c('span',{staticClass:"sr-only"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }